import type { RouteRecordRaw } from 'vue-router';

export const cancelRoutes: Array<RouteRecordRaw> = [
  {
    path: '/cancel/order',
    name: 'cancelOrder',
    redirect: '/cancel/order/list',
    component: () => import('pages/trade/admin/cancelOrder/CancelOrder.vue'),
    meta: {
      title: 'Cancel Order',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'cancelOrderList',
        component: () => import('pages/trade/admin/cancelOrder/CancelOrderList.vue'),
        meta: {
          title: 'Cancel Orders List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'cancelOrderDetail',
        component: () => import('pages/trade/admin/cancelOrder/CancelOrderDetail.vue'),
        meta: {
          title: 'Cancel Order Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'cancelOrderNew',
        component: () => import('pages/trade/admin/cancelOrder/CancelOrderNew.vue'),
        meta: {
          title: 'New Cancel Order',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/cancel/item',
    name: 'cancelItem',
    redirect: '/cancel/item/list',
    component: () => import('pages/trade/admin/cancelItem/CancelItem.vue'),
    meta: {
      title: 'Cancel Order Item',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'cancelItemList',
        component: () => import('pages/trade/admin/cancelItem/CancelItemList.vue'),
        meta: {
          title: 'Cancel Order Items List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'cancelItemDetail',
        component: () => import('pages/trade/admin/cancelItem/CancelItemDetail.vue'),
        meta: {
          title: 'Cancel Order Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'cancelItemNew',
        component: () => import('pages/trade/admin/cancelItem/CancelItemNew.vue'),
        meta: {
          title: 'New Cancel Order Item',
          requiresAuth: true,
        },
      },
    ],
  },
];
